// 吃瓜合集 - 首页门户 mock 数据

export interface HotItem {
  rank: number;
  title: string;
  heat: number;
  tag: string;
  trend: "up" | "down" | "flat";
  desc: string;
}

export interface SerialEvent {
  id: number;
  category: string;
  title: string;
  status: string;
  updateCount: number;
  lastUpdate: string;
  desc: string;
  nodes: { time: string; label: string }[];
  cover: string;
  heat: number;
}

export interface Article {
  id: number;
  category: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  views: number;
  tag: string;
}

export interface TimelineEvent {
  id: number;
  date: string;
  title: string;
  digest: string;
  hot: boolean;
  cover: string;
}

export const categories: string[] = [
  "全部",
  "明星动态",
  "综艺现场",
  "网红圈",
  "直播切片",
  "品牌八卦",
];

export const hotList: HotItem[] = [
  { rank: 1, title: "某国民综艺被曝剪掉大咖争议片段 粉丝连夜翻出未播花絮", heat: 986, tag: "综艺现场", trend: "up", desc: "网友发现正片与预告衔接异常，疑有删减，相关话题讨论量激增。" },
  { rank: 2, title: "当红主播塌房倒计时？旧直播录像被逐帧复盘", heat: 921, tag: "直播切片", trend: "up", desc: "多段历史直播被重新翻出，逐帧对比后评论区炸锅，主播方暂未回应。" },
  { rank: 3, title: "官宣！顶流影视 IP 确认续拍 原班人马却成最大悬念", heat: 874, tag: "明星动态", trend: "up", desc: "续拍消息落地后，谁会回归成了新一轮吃瓜焦点，阵容猜测满天飞。" },
  { rank: 4, title: "品牌直播间“翻车名场面”合集 又被网友做成了表情包", heat: 803, tag: "品牌八卦", trend: "flat", desc: "一次口误引发的连锁反应，正被二创博主循环加工，传播仍在发酵。" },
  { rank: 5, title: "头部网红互撕升级 双方工作室接连发声明打哑谜", heat: 756, tag: "网红圈", trend: "up", desc: "从隔空喊话到正式声明，脉络越盘越乱，吃瓜群众已开始整理时间线。" },
  { rank: 6, title: "综艺名场面考古 十年前的一段话如今全网求考古", heat: 690, tag: "综艺现场", trend: "down", desc: "一句旧年发言被重新解读，考古贴阅读量一夜之间突破新高。" },
];

export const serialEvents: SerialEvent[] = [
  {
    id: 1,
    category: "明星动态",
    title: "当红剧组“离职风波”全程追踪",
    status: "更新中",
    updateCount: 12,
    lastUpdate: "今日 14:20",
    heat: 1200,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20moody%20backstage%20film%20studio%20with%20warm%20amber%20key%20light%20and%20soft%20shadows%2C%20editorial%20portrait%20atmosphere%2C%20film%20crew%20silhouettes%2C%20artistic%20vignette&width=800&height=900&seq=serial-cover-01&orientation=portrait",
    desc: "从一条匿名投稿开始发酵，剧组成员接连发声，事件逐渐走向高潮，全程时间线已整理成串。",
    nodes: [
      { time: "03-21", label: "匿名平台出现爆料帖，矛头指向主创" },
      { time: "03-24", label: "剧组发布首份声明否认，称将保留追责权利" },
      { time: "03-28", label: "多位现场工作人员陆续发声，说法出现分歧" },
      { time: "04-02", label: "片方二次回应，制片人接受采访进一步说明" },
    ],
  },
  {
    id: 2,
    category: "网红圈",
    title: "头部主播商业纠纷 舆论战拉锯全记录",
    status: "更新中",
    updateCount: 8,
    lastUpdate: "昨日 21:05",
    heat: 980,
    cover: "https://readdy.ai/api/search-image?query=dramatic%20newsroom%20desk%20with%20stacked%20newspapers%20and%20phone%20screen%20glare%20in%20warm%20desaturated%20tones%2C%20moody%20editorial%20documentary%20style%2C%20soft%20amber%20lighting&width=800&height=900&seq=serial-cover-02&orientation=portrait",
    desc: "合作方与主播团队各执一词，账目、分成、违约金等多个节点连续反转，吃瓜群众全程跟进。",
    nodes: [
      { time: "04-05", label: "合作方深夜发文控诉分成比例未兑现" },
      { time: "04-08", label: "主播团队回应称合同条款存在争议" },
      { time: "04-12", label: "第三方机构介入，数据报告出炉引热议" },
    ],
  },
  {
    id: 3,
    category: "综艺现场",
    title: "国民综艺录制事故 前后两季悬案关联复盘",
    status: "已完结",
    updateCount: 16,
    lastUpdate: "04-16",
    heat: 860,
    cover: "https://readdy.ai/api/search-image?query=empty%20television%20studio%20set%20with%20spotlight%20and%20stage%20lights%20glowing%20warm%2C%20cinematic%20atmosphere%2C%20editorial%20documentary%20mood%2C%20deep%20shadows&width=800&height=900&seq=serial-cover-03&orientation=portrait",
    desc: "两年前的一起录制中断事件被重新提起，新旧物料对撞后真相逐渐浮出水面，已整理为完整专题。",
    nodes: [
      { time: "02-19", label: "旧年中断片段被考古博主重新发出" },
      { time: "02-22", label: "观众扒出两季节目通告单时间差异" },
      { time: "02-26", label: "节目组就此前的沟通疏漏公开道歉" },
      { time: "03-01", label: "当事人发声还原当天完整经过" },
      { time: "03-06", label: "平台补充说明并附原始录制档案" },
    ],
  },
  {
    id: 4,
    category: "品牌八卦",
    title: "联名款争议背后 品牌公关话术全复盘",
    status: "新开场",
    updateCount: 3,
    lastUpdate: "今日 09:10",
    heat: 640,
    cover: "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20limited%20edition%20product%20boxes%20on%20warm%20backdrop%20with%20dramatic%20studio%20lighting%2C%20documentary%20style%2C%20deep%20tones&width=800&height=900&seq=serial-cover-04&orientation=portrait",
    desc: "联名产品被质疑设计抄袭，品牌回应措辞反复修改，舆情监控下每一步都被截图保存。",
    nodes: [
      { time: "04-17", label: "联名系列开售当晚遭设计对比质疑" },
      { time: "04-18", label: "品牌首版声明删除重发引发猜测" },
    ],
  },
];

export const articles: Article[] = [
  { id: 1, category: "明星动态", title: "前后脚官宣？两位艺人同日营业被扒出同款细节", summary: "同一天、同一造型团队、同款拍摄布景，巧合还是联动？网友已扒出蛛丝马迹，我们来逐条盘一遍。", cover: "https://readdy.ai/api/search-image?query=editorial%20fashion%20magazine%20collage%20with%20two%20silhouettes%20back%20to%20back%2C%20warm%20amber%20and%20cream%20tone%2C%20soft%20studio%20lighting%2C%20minimal%20composition&width=640&height=640&seq=article-01&orientation=squarish", date: "04-17", views: 43200, tag: "热点" },
  { id: 2, category: "综艺现场", title: "热播综艺评分断崖？观众不满的点到底在哪", summary: "从弹幕到评分区，差评关键词高度集中。我们把代表性意见按维度归拢，看看争议到底绕不开哪几个结。", cover: "https://readdy.ai/api/search-image?query=cinematic%20stage%20spotlight%20on%20empty%20chair%20center%20with%20audience%20silhouettes%20blurred%20background%2C%20warm%20dramatic%20lighting%2C%20editorial%20documentary%20feel&width=640&height=640&seq=article-02&orientation=squarish", date: "04-16", views: 35600, tag: "讨论" },
  { id: 3, category: "直播切片", title: "一场直播三次反转 主播当晚状态全解析", summary: "从冷静回应到情绪上头再到收尾圆场，短短三小时里的心态曲线，被切片博主完整保留了下来。", cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20phone%20screen%20showing%20live%20stream%20chat%20comments%20in%20warm%20light%2C%20blurred%20background%2C%20editorial%20screen%20culture%20mood&width=640&height=640&seq=article-03&orientation=squarish", date: "04-15", views: 28900, tag: "切片" },
  { id: 4, category: "网红圈", title: "粉丝群疑云：后援会重组背后的几层解读", summary: "一纸重组公告引发猜疑，有人读出权力更迭，有人读出运营换血，我们把各方声音都摊开来听听。", cover: "https://readdy.ai/api/search-image?query=abstract%20network%20of%20people%20avatars%20connected%20by%20lines%20in%20warm%20orange%20tones%2C%20flat%20editorial%20illustration%20style%2C%20clean%20background&width=640&height=640&seq=article-04&orientation=squarish", date: "04-14", views: 24300, tag: "粉丝圈" },
  { id: 5, category: "品牌八卦", title: "评论区考古成流量密码？品牌翻车盘点出圈", summary: "越来越多的品牌考古视频成为爆款，我们把最出圈的几类整理出来，看看大家到底在乐什么。", cover: "https://readdy.ai/api/search-image?query=stack%20of%20vintage%20product%20packaging%20and%20newspaper%20clippings%20arranged%20flat%2C%20warm%20retro%20tone%2C%20editorial%20still%20life%20documentation&width=640&height=640&seq=article-05&orientation=squarish", date: "04-13", views: 21800, tag: "品牌" },
  { id: 6, category: "明星动态", title: "低调营业十年 为何突然因一段路透刷屏", summary: "一段三秒路透让沉寂已久的名字重回热榜，我们梳理了他近期所有公开动作，找出那股暗流。", cover: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20person%20in%20shadow%20partially%20visible%20in%20warm%20amber%20light%2C%20mysterious%20cinematic%20mood%2C%20film%20noir%20style&width=640&height=640&seq=article-06&orientation=squarish", date: "04-12", views: 19800, tag: "路透" },
  { id: 7, category: "综艺现场", title: "综艺“名场面”考古热 为何旧梗频频翻红", summary: "当一段十年前的节目片段被反复引用，它就不再只是旧物料，而成为当下的社交货币，我们来聊聊原因。", cover: "https://readdy.ai/api/search-image?query=retro%20tv%20set%20with%20vintage%20monitor%20glowing%20warm%20in%20dark%20room%2C%20nostalgic%20editorial%20mood%2C%20cinematic%20lighting&width=640&height=640&seq=article-07&orientation=squarish", date: "04-11", views: 17600, tag: "考古" },
  { id: 8, category: "直播切片", title: "带货主播一句口误 品牌股价之外的舆论蝴蝶效应", summary: "一句口误并不只在直播间内发酵，它会顺着切片、弹幕与二创一路传导，我们画出完整传播路径。", cover: "https://readdy.ai/api/search-image?query=abstract%20butterfly%20wing%20made%20of%20digital%20sound%20waves%20and%20comments%2C%20warm%20gradient%2C%20creative%20editorial%20illustration&width=640&height=640&seq=article-08&orientation=squarish", date: "04-10", views: 15200, tag: "切片" },
];

export const timelineEvents: TimelineEvent[] = [
  { id: 1, date: "04-18", title: "剧组成员连环发声迎来新高潮", digest: "继制片人采访后，又一名现场工作人员公开还原细节，事件关注度再度冲高。", hot: true, cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20crew%20on%20set%20silhouette%20under%20warm%20studio%20light%2C%20editorial%20documentary%20style%2C%20deep%20amber%20tones&width=520&height=520&seq=tl-01&orientation=squarish" },
  { id: 2, date: "04-16", title: "平台发布补充说明并附原始档案", digest: "补充声明中晒出录制时间表与聊天记录节选，试图平息此前的删减质疑。", hot: false, cover: "https://readdy.ai/api/search-image?query=document%20files%20and%20folder%20on%20desk%20with%20warm%20desk%20lamp%2C%20editorial%20office%20documentation%20mood%2C%20soft%20amber%20tones&width=520&height=520&seq=tl-02&orientation=squarish" },
  { id: 3, date: "04-13", title: "品牌删改声明全过程被逐条截图", digest: "从发布到删除再到重发，三个版本的措辞差异被做成对照图，传播持续扩散。", hot: false, cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20person%20typing%20on%20laptop%20editing%20text%20document%2C%20warm%20office%20lighting%2C%20editorial%20tech%20mood&width=520&height=520&seq=tl-03&orientation=squarish" },
  { id: 4, date: "04-10", title: "旧年综艺中断片段考古帖破圈", digest: "一条考古微博被搬运到多个平台，旧年争议重新回到大众视野并被重新解读。", hot: true, cover: "https://readdy.ai/api/search-image?query=archival%20tv%20footage%20vhs%20style%20rewind%20effect%20in%20warm%20retro%20tones%2C%20nostalgic%20editorial%20mood&width=520&height=520&seq=tl-04&orientation=squarish" },
  { id: 5, date: "04-07", title: "粉丝后援会发布重组与交接公告", digest: "公告措辞谨慎，但评论区解读各异，管理团队更替的传闻随之升温。", hot: false, cover: "https://readdy.ai/api/search-image?query=group%20of%20people%20silhouettes%20standing%20in%20a%20row%20under%20warm%20light%2C%20community%20management%20concept%2C%20editorial%20style&width=520&height=520&seq=tl-05&orientation=squarish" },
  { id: 6, date: "04-04", title: "主播团队深夜发布长文回应分成争议", digest: "长文梳理了合作时间线与付款记录，试图为持续数日的舆论战定调。", hot: false, cover: "https://readdy.ai/api/search-image?query=hand%20holding%20phone%20reading%20long%20text%20at%20night%20with%20warm%20screen%20glow%2C%20editorial%20night%20scene%20mood&width=520&height=520&seq=tl-06&orientation=squarish" },
];

export const testimonials = [
  { name: "爱看瓜的喵", tag: "追更 120 天", text: "之前最怕瓜挖到一半就断更，在这里能顺着时间线一次看完整，太省心了。" },
  { name: "泡面配综艺", tag: "事件梳理粉", text: "每个节点的出处和原话都有标注，不空口说白话，这点做得特别良心。" },
  { name: "蹲点第一名", tag: "评论区常驻", text: "老板吃瓜更省心这句真的没夸张，更新的瓜从来不让我错过后续。" },
];

export const faqs = [
  { q: "吃瓜合集的更新频率是怎样的？", a: "热门事件发酵期间，我们会对重点连载瓜保持高频跟进，通常每天多次补充最新节点；普通内容则按栏目每日更新，确保时间线始终完整、可追溯。" },
  { q: "合集里的时间线和原话可以放心引用吗？", a: "我们尽量为关键节点标注来源与出处，还原当事人公开发言或官方声明的原始措辞。涉及传播时仍建议以官方渠道信息为准，多方交叉核实。" },
  { q: "为什么有些瓜会标注“更新中”或“已完结”？", a: "“更新中”代表事件仍在发酵、我们将持续补充后续；标注“已完结”则表示我们已尽力把已知脉络整理完整，若之后有新进展也会重新开篇更新。" },
  { q: "我能投稿分享自己关注的瓜吗？", a: "当然可以。你可以通过页面底部的联系反馈表单告诉我们你正在追踪的话题，编辑部评估后会把它加入跟踪列表并整理成时间线。" },
  { q: "信息那么多，如何保证整理内容的质量？", a: "我们坚持一事一链：每次更新都会附上对应的时间与事实节点，尽可能区分已核实信息与猜测，尽量不让主观推测与客观还原混在一起。" },
];